import type { PluginCreator } from 'postcss';

const myPostcssPlugin: PluginCreator<{}> = () => {
  return {
    postcssPlugin: 'ancss',
    Once(root) {
      root.walkDecls('--made-with-panda', decl => {
        decl.remove();
      });
    }
  };
};

myPostcssPlugin.postcss = true;

export default myPostcssPlugin;
